import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { GetAuthTokenAsync } from './GetAuthToken';

const ContentDownload: React.FC = () => {
  const params = useParams<{ itemName: string }>();
  const itemName = params.itemName;
  const hasRun = useRef(false);
  var [pdfUrl, setPdfUrl] = useState<string | null>(null);
  
  const hashFragment = window.location.hash;
  const pageNumberMatch = hashFragment.match(/#page=(\d+)/);
  var pageNumber = pageNumberMatch ? parseInt(pageNumberMatch[1], 10) : null;

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      const fetchFileData = async () => {
        try {
          const result = await GetAuthTokenAsync();
          const accessToken: string = result;
          const requestOptions: RequestInit = {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${accessToken}`
            },
          };

          const response = await fetch(process.env.REACT_APP_WEB_API_URL + `Content/${itemName}`, requestOptions);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          let base64String = await response.text();
          base64String = base64String.replace(/\"/g, "");
          base64String = base64String.replace(/\\n/g, "");
          base64String = base64String.replace(/\\\\/g, "\\");

          const binaryString = window.atob(base64String);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes.buffer], { type: 'application/pdf' });

          const url = window.URL.createObjectURL(blob);
          setPdfUrl(url);
        } catch (error) {
          console.error('There was an error!', error);
        }
      };

      fetchFileData();
    }
  }, [itemName]);

  useEffect(() => {
    if (pdfUrl) {
      
      const destinationUrl = pageNumber ? `${pdfUrl}#page=${pageNumber}` : pdfUrl;
      const newTab = window.open(destinationUrl, '_blank');
      
      if (newTab) {
        window.close();
      } else {
        console.error("Failed to open the PDF in a new tab.");
      }
    }
  }, [pdfUrl, pageNumber]);

  return null;
};

export default ContentDownload;
